import { cuppingDescriptorHierarchy } from '../constants/cuppingDescriptorValues';
export var cuppingDescriptorWithAncestor = (function () {
    var arr = [];
    Object.assign(cuppingDescriptorHierarchy).children.forEach(function (grandparent) {
        var _a;
        arr.push({ name: grandparent.name });
        if (grandparent.children && grandparent.children.length > 0) {
            (_a = grandparent.children) === null || _a === void 0 ? void 0 : _a.forEach(function (parent) {
                var _a;
                arr.push({ name: parent.name, ancestor: [grandparent.name] });
                if (parent.children && parent.children.length > 0) {
                    (_a = parent.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
                        arr.push({
                            name: child.name,
                            ancestor: [grandparent.name, parent.name],
                        });
                    });
                }
            });
        }
    });
    return arr;
})();
export var descriptors = cuppingDescriptorWithAncestor
    .map(function (_a) {
    var name = _a.name;
    return name;
})
    .sort()
    .filter(function (name, index, array) { return array.indexOf(name) === index; });
export var hasCommaDescriptors = descriptors.filter(function (descriptor) {
    return descriptor.includes(',');
});
